export default {
  currentApplication(state) {
    return state.currentApplication
  },
  currentReport(state) {
    return state.currentReport
  },
}
